export const environment = {
    production: false,
    apiUrl: "https://dev.api.nightweb.noveltytechnology.com/api/v2/web",
    notificationUrl: "https://dev.api.nightweb.noveltytechnology.com"
  };
  